import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';
import { alpha, styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton, Typography, Dialog, DialogTitle } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
// hooks
import useCollapseDrawer from '../../hooks/useCollapseDrawer';
// components
import { MHidden } from '../../components/@material-extend';
import AccountPopover from './AccountPopover';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'redux/store';
import { getCurrentSubscription } from 'redux/slices/subscription';

import AddEan from 'components/_dashboard/katalog/AddEan';
import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 119;
const COLLAPSE_WIDTH = 102;

const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 64;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: '1',
  backgroundColor: alpha(theme.palette.background.default, 0), // 0.72
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${DRAWER_WIDTH}px)`
  }
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5)
  }
}));

// ----------------------------------------------------------------------

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func
};

export default function DashboardNavbar({ onOpenSidebar }) {
  const { t } = useTranslation();

  const { isCollapse } = useCollapseDrawer();

  const dispatch = useDispatch();
  const { currentSubscription } = useSelector((state: any) => state.subscription);

  const [usage, setUsage] = useState(0);
  const [monthLimit, setMonthLimit] = useState(0);
  const [ratio, setRatio] = useState(0);

  useEffect(() => {
    dispatch(getCurrentSubscription());
  }, []);

  const [dialog, setDialog] = useState(false);

  const handleCloseEan = async () => {
    setDialog(false);
  };

  useEffect(() => {
    if (JSON.stringify(currentSubscription) !== '{}') {
      setUsage(
        currentSubscription &&
          currentSubscription.counters &&
          currentSubscription.counters.length > 0 &&
          currentSubscription.counters[0].create
          ? currentSubscription.counters[0].create
          : 0
      );
      setMonthLimit(
        currentSubscription &&
          currentSubscription.subscription &&
          currentSubscription.subscription.limitation &&
          currentSubscription.subscription.limitation.limitPerMonth != 0
          ? currentSubscription.subscription.limitation.limitPerMonth
          : currentSubscription &&
            currentSubscription.subscription &&
            currentSubscription.subscription.limitation &&
            currentSubscription.subscription.limitation.limitPerDay != 0
          ? currentSubscription.subscription.limitation.limitPerDay
          : 0
      );
      setRatio((usage / monthLimit) * 100);
    }
  }, [currentSubscription]);

  return (
    <>
      <RootStyle
        sx={{
          ...(isCollapse && {
            width: { lg: `calc(100% - ${COLLAPSE_WIDTH}px)` }
          })
        }}
      >
        <ToolbarStyle sx={{ backgroundColor: 'white', zIndex: 999 }}>
          <MHidden width="lgUp">
            <IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary' }}>
              <Icon icon={menu2Fill} />
            </IconButton>
          </MHidden>
          {/* <Searchbar /> */}

          <Box sx={{ flexGrow: 1 }} />

          <Stack sx={{ mr: 2 }}>
            <Typography>
              <span style={{ fontWeight: 'bold', color: '#000000' }}>
                {usage} of {monthLimit} {t('navBar.datasets')}{' '}
              </span>
            </Typography>
            <LinearProgress variant="determinate" value={ratio} color="success" />
          </Stack>

          <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
            <AccountPopover />
          </Stack>
        </ToolbarStyle>
      </RootStyle>

      <Dialog open={dialog} onClose={handleCloseEan} fullWidth maxWidth="md">
        <DialogTitle>{t('product.createProduct')}</DialogTitle>
        <AddEan onCloseEan={handleCloseEan} />
      </Dialog>
    </>
  );
}
